import React, { useState } from 'react';
import './careers.css'
 
import '@fortawesome/fontawesome-free/css/all.min.css';

import { Modal, Button, Form } from "react-bootstrap";
import emailjs from "@emailjs/browser";
import "bootstrap/dist/css/bootstrap.min.css";
import career from '../../../img/career home.svg';
import career1 from '../../../img//image_processing2021.svg';
import career2 from '../../../img/career-last.jpg';

const Careers = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const accordionData = [
      {
        title: 'Software Engineer (AI & ML Integration)',
        items: [
          'Develop and implement AI and machine learning models for custom business solutions.',
          'Work closely with our data engineering team to build scalable data pipelines.',
          'Experience with Python, TensorFlow, and cloud services like AWS or Azure preferred.',
        ],
      },
      {
        title: 'Cloud Infrastructure Specialist',
        items: [
          'Optimize and manage cloud environments, ensuring performance, cost-efficiency, and security.',
          'Expertise in multi-cloud strategies, Kubernetes, and DevOps practices is a plus.',
          'Hands-on experience with cloud providers such as AWS, Google Cloud, or Azure.',
        ],
      },
      {
        title: 'Full-Stack Developer (SaaS Focus)',
        items: [
          'Design and develop scalable SaaS solutions using modern frameworks like Ruby on Rails and React.',
          'Collaborate closely with our UI/UX designers to ensure seamless user experiences.',
          'Prior experience in cloud-native application development is highly desired.',
        ],
      },
      {
        title: 'UI/UX Designer',
        items: [
          'Create intuitive user interfaces and experiences for our clients’ web and mobile applications.',
          'Strong background in responsive design, user research, and wireframing tools like Figma or Sketch.',
          'A portfolio showcasing previous UI/UX work is required.',
        ],
      },
    ];
  
    const toggleAccordion = (index) => {
      setOpenIndex(openIndex === index ? null : index);
    };

    const [showModal, setShowModal] = useState(false);
        const [show, setShow] = useState(false);
        const handleClose = () => setShow(false);
        const handleShow = () => setShow(true);
      
        const [formData, setFormData] = useState({
          name: "",
          email: "",
          phone: "",
          position: "",
          message: "",
        });
      
        const [resumeFile, setResumeFile] = useState(null);
      
        const handleChange = (e) => {
          const { id, value } = e.target;
          setFormData((prev) => ({
            ...prev,
            [id]: value,
          }));
        };
      
        const handleSubmit = (e) => {
          e.preventDefault();
      
          // Resume validation
          if (!resumeFile) {
            alert("Please upload your resume.");
            return;
          }
      
          const allowedExtensions = /(.pdf|.doc|.docx)$/i;
          if (!allowedExtensions.exec(resumeFile.name)) {
            alert("Please upload a valid resume file (PDF, DOC, DOCX).");
            return;
          }
      
          const templateParams = {
            from_name: formData.name,
            reply_to: formData.email,
            message: `
              Name: ${formData.name}
              Email: ${formData.email}
              Phone: ${formData.phone}
              Position: ${formData.position}
              Message: ${formData.message}
            `,
          };
      
          emailjs
            .send("service_a0k87hd", "template_ijwt0wl", templateParams, "6nHi2Lr__5gXhYgu6")
            .then((response) => {
              alert("✅ Thank you! Your application has been sent.");
              handleClose();
              setFormData({
                name: "",
                email: "",
                phone: "",
                position: "",
                message: "",
              });
              setResumeFile(null);
            })
            .catch((error) => {
              console.error("EmailJS Error:", error);
              alert("❌ Failed to send application. Please try again.");
            });
        };
      
  
  return (
    <div>
    <section>
        <div className="container fade-in-top">

            <div className="team-sectionA row align-items-center mt-5">
                <div className="team-textA col-md-6">
                    <h2>Join the CodeQlik Team</h2>
                    <p>Are you ready to work on cutting-edge projects and build world-className software solutions? At
                        CodeQlik, we're constantly seeking talented professionals who share our passion for innovation
                        and excellence in technology. Be part of a dynamic team that's driving digital transformation
                        for businesses across the U.S.!</p>
                </div>
                <div className="team-illustrationA col-md-6 text-center">
                    <img src={career} alt="Illustration"/>
                </div>
            </div>
        </div>
    </section>

    <section>
        <div className="container py-5">
            <h2 className="career-heading text-center fw-bold mb-4">Why Work at CodeQlik?</h2>
            <div className="row g-4">
                <div className="col-md-6 col-sm-12 d-flex" data-aos="fade-up" data-aos-delay="0">
                    <div className="feature-box1 p-4 w-100">
                        <div className="feature-number1">01</div>
                        <div className="feature-title1">Innovative Projects</div>
                        <p className="work-text-career">Get hands-on with AI, Machine Learning, Cloud Solutions, and SaaS
                            development. Shape the
                            future of tech with real impact.</p>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 d-flex" data-aos="fade-up" data-aos-delay="100">
                    <div className="feature-box1 p-4 w-100">
                        <div className="feature-number1">02</div>
                        <div className="feature-title1">Collaborative Environment</div>
                        <p className="work-text-career">Work alongside industry experts who foster creativity, share knowledge, and
                            celebrate
                            achievements.</p>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 d-flex" data-aos="fade-up" data-aos-delay="200">
                    <div className="feature-box1 p-4 w-100">
                        <div className="feature-number1">03</div>
                        <div className="feature-title1">Growth and Development</div>
                        <p className="work-text-career">We invest in our people with opportunities for career advancement, skill
                            enhancement, and
                            professional growth.</p>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 d-flex" data-aos="fade-up" data-aos-delay="300">
                    <div className="feature-box1 p-4 w-100">
                        <div className="feature-number1">04</div>
                        <div className="feature-title1">Flexible Work Culture</div>
                        <p className="work-text-career">Balance life and work with remote options and flexible schedules to perform
                            at your best.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
    <div className="container mt-5">
      <h2 className="fw-bold mb-4 career-heading">Current Openings</h2>
      {accordionData.map((item, index) => (
        <div className="accordion" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
          <div className="accordion-header d-flex justify-content-between align-items-center" onClick={() => toggleAccordion(index)} style={{ cursor: 'pointer' }}>
            <h3>{item.title}</h3>
            <div className="caret-box">
              <span className="caret">
                <i className={`fa-solid ${openIndex === index ? 'fa-minus' : 'fa-plus'}`}></i>
              </span>
            </div>
          </div>
          {openIndex === index && (
            <div className={`accordion-content ${openIndex === index ? 'show' : 'hide'}`}>
              <ul className="career-text">
                {item.items.map((text, i) => (
                  <li key={i}>{text}</li>
                ))}
              </ul>
              <div className="text-center py-2">
              <button className="btn apply-job" onClick={handleShow}>
          Apply Now
        </button>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
    <div className="text-center">
        <button className="btn apply-job" onClick={handleShow}>
          Apply Now
        </button>
      </div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Apply for a Job</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control id="name" value={formData.name} onChange={handleChange} required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" id="email" value={formData.email} onChange={handleChange} required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="tel"
                id="phone"
                value={formData.phone}
                onChange={handleChange}
                maxLength="10"
                pattern="[0-9]{10}"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Position</Form.Label>
              <Form.Select id="position" value={formData.position} onChange={handleChange} required>
                <option value="" disabled>Select a Position</option>
                <option>Software Engineer</option>
                <option>Web Developer</option>
                <option>UI/UX Designer</option>
                <option>Digital Marketer</option>
                <option>Project Manager</option>
                <option>Internship</option>
                <option>Other</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control as="textarea" rows={3} id="message" value={formData.message} onChange={handleChange} required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Upload Resume (PDF/DOC/DOCX)</Form.Label>
              <Form.Control
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={(e) => setResumeFile(e.target.files[0])}
                required
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <Button type="submit" className="btn apply-job">
              Submit Application
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </section>

    <section>
        <div className="container custom-containerA">
            <div className="row align-items-center">
                <div className="col-md-7">
                    <h2 className="section-titleA">What You Can Expect</h2>

                    <div className="mt-4" data-aos="fade-up" data-aos-delay="0">
                        <h5 className="highlightA">Competitive Salary & Benefits</h5>
                        <p className="text-career1">We offer a market-competitive salary, healthcare, and benefits package,
                            including wellness
                            programs.</p>
                    </div>

                    <div className="mt-4" data-aos="fade-up" data-aos-delay="100">
                        <h5 className="highlightA">Remote-Friendly Work Options</h5>
                        <p className="text-career1">Whether you're at home, in one of our global offices, or traveling, you
                            have the flexibility
                            to work where you're most comfortable.</p>
                    </div>

                    <div className="mt-4" data-aos="fade-up" data-aos-delay="200">
                        <h5 className="highlightA">A Chance to Innovate</h5>
                        <p className="text-career1">Be part of a team that's not just adopting new technologies but creating
                            them. From AI-native
                            development to cloud infrastructure optimization, we’re shaping the future.</p>
                    </div>
                </div>

                <div className="col-md-5 text-center img-containerA" data-aos="fade-up" data-aos-delay="0">
                    <img src={career1} alt="Illustration"/>
                </div>
            </div>
        </div>
    </section>


    <section>
        <div className="container values-section">
            <h2 className="values-title">Our Culture and Values</h2>
            <p className="values-text">
                At CodeQlik, we're more than just a tech company. We're a community of innovators, problem-solvers,
                and collaborators who value:
            </p>
            <div className="row g-4">
                <div className="col-lg-4 col-sm-4" data-aos="fade-up" data-aos-delay="0">
                    <div className="value-card ">
                        <div className="value-icon"><i className="fa-solid fa-bolt"></i></div>
                        <h5 className="value-title">Excellence</h5>
                        <p className="value-description">Delivering the highest quality in every project.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-sm-4" data-aos="fade-up" data-aos-delay="100">
                    <div className="value-card text-center">
                        <div className="value-icon">🔄</div>
                        <h5 className="value-title">Curiosity</h5>
                        <p className="value-description">Exploring new technologies and challenging the status quo.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-sm-4" data-aos="fade-up" data-aos-delay="200">
                    <div className="value-card text-center">
                        <div className="value-icon"><i className="fa-solid fa-crown"></i></div>
                        <h5 className="value-title">Empathy</h5>
                        <p className="value-description">Understanding our clients, users, and teammates to build better
                            solutions.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div className="container">
            <div className="apply-section" data-aos="fade-up" data-aos-delay="0">
                <h2 className="fw-bold">How to Apply</h2>
                <p>Interested in joining our team? We'd love to hear from you!</p>
                <p>Send your resume and portfolio to <strong>careers@CodeQlik.dev</strong></p>
                {/* <!-- <button className="apply-btn" ><a href="#form-started">Get Started</a> </button> --> */}
                <button className="btn apply-job" onClick={handleShow}>
          Apply Now
        </button>
            </div>
        </div>
    </section>
    <section>
        <div className="container stay-connected">
            <div className="row align-items-center" data-aos="fade-up" data-aos-delay="0">
                {/* <!-- Text Content --> */}
                <div className="col-lg-6 text-center text-lg-start">
                    <h2 className="fw-bold career-heading">Stay Connected</h2>
                    <p>Follow us on LinkedIn and Facebook to keep up with the latest job opportunities, company news,
                        and tech insights from CodeQlik.</p>
                  
                </div>

                {/* <!-- Illustration --> */}
                <div className="col-lg-6 text-center illustrationB">
                    <img src={career2} alt="Rocket Launch Illustration"/>
                </div>
            </div>
        </div>
    </section></div>
  )
}

export default Careers